import PropTypes from 'prop-types';

export const PROPTYPE_SUBSCRIPTION = PropTypes.shape({
  modality: PropTypes.string,
  id: PropTypes.string,
  lkDay: PropTypes.number,
});
